module.exports = __webpack_public_path__ + "static/media/imd-clock-icn.6b1bd85f.png";